import { render, staticRenderFns } from "./ScrollContext.vue?vue&type=template&id=3b6c7973"
import script from "./ScrollContext.vue?vue&type=script&lang=ts"
export * from "./ScrollContext.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports